export default "__VITE_ASSET__CmUyIpCW__"